import EventEmitter from 'eventemitter3';
import ColorDisablerButtonsEvents from '../events/ColorDisablerButtonsEvents';
import { getMovieClipByName, MovieClip, Stage } from '../utils/utils';

// ==================================================================================================
type ButtonCallback = (...args: unknown[]) => void;

export default class ColorDisablerButtons {
  // ================================================================================================
  // properties
  // ================================================================================================
  private stage: Stage;

  private _events: EventEmitter;

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor(stage: Stage) {
    this._events = new EventEmitter();
    this.stage = stage;
    this.initButtons();
  }

  // ----------------------------------------------------------------------------------------------
  get events(): EventEmitter {
    return (this._events);
  }

  // ================================================================================================
  // private
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  private initButton(buttonName: string, pressedCallback: ButtonCallback): MovieClip {
    const button = getMovieClipByName(this.stage, buttonName);
    if (button) {
      button.addEventListener('click', pressedCallback.bind(this));
      button.addEventListener('mouseover', this.onButtonMouseOver.bind(this));
    }

    return (button);
  }

  // ----------------------------------------------------------------------------------------------
  private initButtons(): void {
    this.initButton('btnMainColorDisabler', this.onMainButtonPressed);
    this.initButton('btnSecondColorDisabler', this.onSecondButtonPressed);
    this.initButton('btnThirdColorDisabler', this.onThirdButtonPressed);
  }

  // ----------------------------------------------------------------------------------------------
  private onButtonMouseOver(): void {
    this._events.emit(ColorDisablerButtonsEvents.DISABLER_BUTTON_OVER, this);
  }

  // ----------------------------------------------------------------------------------------------
  private onMainButtonPressed(): void {
    this._events.emit(ColorDisablerButtonsEvents.MAIN, this);
  }

  // ----------------------------------------------------------------------------------------------
  private onSecondButtonPressed(): void {
    this._events.emit(ColorDisablerButtonsEvents.SECOND, this);
  }

  // ----------------------------------------------------------------------------------------------
  private onThirdButtonPressed(): void {
    this._events.emit(ColorDisablerButtonsEvents.THIRD, this);
  }
}
